
import React from 'react';
import { ShoppingCart, BarChart3, Lightbulb, Sparkles } from 'lucide-react';
import { LocalizedContent } from '../utils/localization';

interface UseCasesProps {
  content: LocalizedContent;
}

const UseCases: React.FC<UseCasesProps> = ({ content }) => {
  const iconMapping = [
    <ShoppingCart className="text-purple-400 mt-1" size={24} />,
    <BarChart3 className="text-purple-400 mt-1" size={24} />,
    <Lightbulb className="text-purple-400 mt-1" size={24} />,
    <Sparkles className="text-purple-400 mt-1" size={24} />
  ];

  return (
    <section className="py-16 bg-[#0F0F15]">
      <div className="container mx-auto px-4">
        <div className="max-w-5xl mx-auto">
          <h2 className="text-3xl font-bold text-center mb-12 text-white font-future">{content.useCasesTitle}</h2>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {content.useCases.map((useCase, index) => (
              <div key={index} className="bg-[#181825] p-6 rounded-lg border border-purple-900/20 flex gap-4 items-start">
                {iconMapping[index]}
                <div>
                  <h3 className="text-xl font-semibold mb-2 text-white">{useCase.title}</h3>
                  <p className="text-gray-400">{useCase.description}</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default UseCases;
